import { ActionArgs } from '../../action/ActionArgs'
import { Field, Float, InputType } from 'type-graphql'

@InputType()
export class OrderItemUpdateShippingWeightArgs extends ActionArgs {
  @Field(() => Float)
  quantity: number

  @Field(() => Float)
  weight: number

  @Field(() => String)
  productId: string

  @Field(() => String)
  orderId: string
}
